const bodyTag = document.getElementsByTagName('body')[0];

export function addBodyClass(className: string) {
    bodyTag.classList.add(className);
}

export function removeBodyClass(className: string) {
    bodyTag.classList.remove(className);
}
